import { render, staticRenderFns } from "./VehicleManagement.vue?vue&type=template&id=824f4590&scoped=true&"
import script from "./VehicleManagement.vue?vue&type=script&lang=ts&"
export * from "./VehicleManagement.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleManagement.vue?vue&type=style&index=0&id=824f4590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824f4590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VHover,VIcon,VRow})
